"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Inline_1 = __importDefault(require("../../layouts/Inline"));
const Stack_1 = __importDefault(require("../../layouts/Stack"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const Modal_1 = __importDefault(require("../../components/Modal"));
const FormField_1 = __importDefault(require("../../components/FormField"));
const Input_1 = __importDefault(require("../../components/Input"));
const Button_1 = __importDefault(require("../../components/Button"));
/**
 * A model dialog used to verify users truly intend to perform deletion or some kind of destructive action. <br/>
 * When deleting resources, you can choose between different levels of friction: <b>friction</b> or <b>confirmation</b>.
 * */
const DeleteConfirmationDialog = (_a) => {
    var { visible, onDeleteClicked, onCancelClicked, loading = false, enabled = true, title, children, deleteButtonText } = _a, props = __rest(_a, ["visible", "onDeleteClicked", "onCancelClicked", "loading", "enabled", "title", "children", "deleteButtonText"]);
    const [confirmation, setConfirmation] = react_1.useState('');
    const [isMatched, setIsMatched] = react_1.useState(props.variant === 'confirmation');
    const confirmationText = (props.variant !== 'confirmation' && props.confirmationText) || 'delete';
    const handleDelete = react_1.useCallback(() => {
        setConfirmation('');
        onDeleteClicked === null || onDeleteClicked === void 0 ? void 0 : onDeleteClicked();
    }, [onDeleteClicked]);
    const handleCancel = react_1.useCallback(() => {
        setConfirmation('');
        onCancelClicked === null || onCancelClicked === void 0 ? void 0 : onCancelClicked();
    }, [onCancelClicked]);
    const actions = react_1.useMemo(() => (react_1.default.createElement(Box_1.default, { display: "flex", width: "100%", justifyContent: "flex-end" },
        react_1.default.createElement(Inline_1.default, null,
            react_1.default.createElement(Button_1.default, { label: "close", onClick: handleCancel }, "Cancel"),
            react_1.default.createElement(Button_1.default, { label: "delete", variant: "primary", disabled: !enabled || !isMatched || loading, loading: loading, onClick: handleDelete }, deleteButtonText || 'Delete')))), [deleteButtonText, handleCancel, handleDelete, loading, isMatched, enabled]);
    react_1.useEffect(() => {
        setIsMatched(props.variant === 'confirmation' || confirmationText === confirmation);
    }, [setIsMatched, confirmation, confirmationText, props.variant]);
    return (react_1.default.createElement(Modal_1.default, { visible: visible, title: title, footer: actions, onClose: handleCancel },
        react_1.default.createElement(Stack_1.default, null,
            children,
            props.variant !== 'confirmation' && (react_1.default.createElement(FormField_1.default, { label: props.label || (react_1.default.createElement(react_1.default.Fragment, null,
                    "To confirm deletion, type ",
                    react_1.default.createElement("i", null, "delete"),
                    " below")), controlId: "confirmation", hintText: props.hintText },
                react_1.default.createElement(Input_1.default, { type: "text", placeholder: props.placeholderText || confirmationText, value: confirmation, onChange: setConfirmation }))))));
};
exports.default = DeleteConfirmationDialog;
//# sourceMappingURL=index.js.map